// Client layer (TS-2.5.03) - the product catalogue (D-266/D-267): ProductsController's four
// routes, mirroring portfolioData.ts's shape. There is deliberately no `deleteProduct`: D-268
// routes no DELETE verb at all, because a product leaves service by being saved with
// `isActive: false` (retirement), not by disappearing out from under a project that still names it.
import { http } from "./http";
import type { ProductRecord, ProductSaveRequest, SaveResult } from "./generated/contracts";

export const productsApi = {
  /** Defaults to active-only (D-268's picker-safe default); pass `true` for the admin catalogue. */
  listProducts: (includeRetired = false) =>
    http.get<ProductRecord[]>("/api/products", { query: { includeRetired } }),

  getProduct: (productKey: string) => http.get<ProductRecord>(`/api/products/${productKey}`),

  createProduct: (request: ProductSaveRequest) =>
    http.post<SaveResult<ProductRecord>>("/api/products", { body: request }),

  updateProduct: (productKey: string, request: ProductSaveRequest) =>
    http.put<SaveResult<ProductRecord>>(`/api/products/${productKey}`, { body: request }),
};
